<template>
  <offer-layout class="conditionalOffer">
    <heading level="2" class="heading">{{ $t('offer.conditional.heading') }}</heading>

    <div class="content">
      <div class="contentSection aboutProduct">
        <div class="productName">{{ $t('offer.productName') }}</div>
        <div class="upTo">{{ $t('offer.upTo') }}</div>
        <div class="maxAmount">{{ formatMoney(maxLoanAmount, 0) }}</div>
        <div class="productDescription" v-if="filteredAdrs.length > 0">
          {{ $t('offer.productDescription', { daysNumber: expirationDays }) }}
        </div>
        <div class="conditionalOfferDescription" v-else>
          {{ $t('offer.conditionalOfferDescription') }}
        </div>
      </div>
      <div class="contentSection requiredDocuments" v-if="filteredAdrs.length > 0">
        <template>
          <div class="listTitle">{{ $t('offer.requiredDocuments.title') }}</div>
          <ul class="documentList">
            <li
              v-for="adr in filteredAdrs"
              :key="adr.id"
              class="documentListItem"
              :title="adr.requestDetails.details"
            >
              <svg-use class="icon" name="Icons _ 02 Operations _ Document" />
              <span>{{ adr.template.template.details }}</span>
            </li>
          </ul>
        </template>
        <brand-button class="continueButton" @click="submitConditionalOffer">
          {{ $t('offer.conditional.continueButtonText') }}
        </brand-button>
      </div>
    </div>
  </offer-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OfferLayout from '@/views/layouts/OfferLayout';
import money from '@/filters/money';
import percent from '@/filters/percent';
import applicationMixin from '@/mixins/application';
import adrStatuses from '@/constants/adr-statuses';

export default {
  name: 'conditional-offer',
  components: {
    OfferLayout,
  },
  computed: {
    ...mapGetters({
      offers: 'offer/getOffers',
      adrs: 'adrs/getAdrs',
    }),
    filteredAdrs() {
      return this.adrs.filter(adr => adr.status === adrStatuses.REQUESTED);
    },
    offer() {
      return this.offers[0];
    },
    maxLoanAmount() {
      const amounts = this.offers.map(offer => offer.line);
      return Math.max(...amounts);
    },
    expirationDays() {
      const expirationDate = new Date(this.offer.expirationDate);
      const currentDate = new Date();
      const oneDay = 86400000; // one day in milliseconds
      return Math.round(Math.abs((expirationDate - currentDate) / oneDay));
    },
  },
  mixins: [applicationMixin],
  methods: {
    formatMoney: money,
    formatPercent: percent,
  },
};
</script>

<style lang="sass" scoped>

.conditionalOffer
  color: $font-color-dark

.heading
  text-align: center
  margin-top: baseunit(6.8)

.content
  background: $color-system-neutral-white
  margin: $glass-spacing-3 auto $glass-spacing-6
  padding: $glass-spacing-3
  border-radius: 4px
  border: 1px solid $color-system-neutral-gray-3
  +mq($tyranno)
    max-width: baseunit(68)

  .contentSection
    &:not(:first-of-type)
      padding-top: $glass-spacing-3
      border-top: 1px solid $color-system-neutral-gray-3
    &:not(:last-of-type)
      padding-bottom: $glass-spacing-3

.aboutProduct
  text-align: center

  .productName
    +font-size(16, 28)
    font-weight: bold
  .upTo
    +font-size(13.33, 20)
    color: $color-system-neutral-gray-5
  .maxAmount
    +font-size(32, 32)
    margin-top: $glass-spacing-05
    color: $glass-color-brand-primary-dark-03
  .productDescription
    +font-size(13.33, 20)
    margin-top: $glass-spacing-105
  .conditionalOfferDescription
    +font-size(13.33, 20)
    margin-top: $glass-spacing-105
    color: $glass-color-brand-primary-dark-03

.requiredDocuments
  .listTitle
    font-weight: bold
    margin-top: 0
    +font-size(16, 20)

  .documentList
    margin-top: $glass-spacing-2
    padding: 0
    list-style: none
    +font-size(13.33, 20)

    .documentListItem
      display: flex
      align-items: center

      &:not(:first-of-type)
        margin-top: $glass-spacing-1

      .icon
        width: baseunit(2)
        height: baseunit(2)
        margin-right: $glass-spacing-05
        color: $color-system-neutral-gray-5

.continueButton
  margin-top: $glass-spacing-4
</style>
